"use strict";import{html as s}from"@cisco-u/base";export function menuIcon({height:e=24,width:l=24,hidden:r=!1,title:t=""}={}){return s`<svg
    class="menu-svg"
    xmlns="http://www.w3.org/2000/svg"
    width=${l}
    height=${e}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="${r?"true":"false"}"
    aria-label="${t}"
    preserveAspectRatio="none"
  >
    <g>
      <path
        class="line-1"
        d="M 22 19.1077 H 2 V 20.3077 H 22 V 19.1077 Z"
        fill="currentColor"
      />
      <path
        class="line-2"
        d="M 22 11.354 H 2 V 12.554 H 22 V 11.354 Z"
        fill="currentColor"
      />
      <path
        class="line-3"
        d="M 22 3.59998 H 2 V 4.79998 H 22 V 3.59998Z"
        fill="currentColor"
      />
    </g>
  </svg>`}
//# sourceMappingURL=menu-icon.js.map
